import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const ENV_ENDPOINTS = {
  local: "http://localhost:5613",
  development: "https://api.next.crm.lafactory.co/dev",
  staging: "https://api.next.crm.lafactory.co/staging",
  production: "https://api.next.crm.lafactory.co/prod"
};

const BASE = `${ENV_ENDPOINTS[process.env.REACT_APP_ENV]}/api/activities`;

const WEBSITE_API = id => `${BASE}/${id}/website`;

const slice = createSlice({
  name: "activity",
  initialState: null,
  reducers: {
    _addActivityToStore(state, action) {
      return action.payload;
    }
  }
});

const { _addActivityToStore } = slice.actions;

export default slice.reducer;

export const fetchById = _id => async dispatch => {
  try {
    const resp = await axios.get(WEBSITE_API(_id));
    if (resp.data && resp.data.success && resp.data.data) {
      dispatch(_addActivityToStore(resp.data.data));
      return resp.data.data;
    }
    throw new Error("Something went wrong!");
  } catch (err) {
    const error = err.message || "Something went wrong";
    alert(error);
    return null;
  }
};
